// NORM CASE API
import Request from '../base'
export default {
  save (options) {
    return Request.post('/ebermain/mainapi/databank/normCasePraise/save', options)
  },
  lookup (options) {
    return Request.post('/ebermain/mainapi/databank/normCasePraise/updateLookup', options)
  },
  count (options) {
    return Request.post('/ebermain/mainapi/databank/normCasePraise/count', options)
  },
  list (options) {
    return Request.post('/ebermain/mainapi/databank/normCasePraise/list', options)
  },
  find (pagination, options) {
    return Request.post('/ebermain/mainapi/databank/normCasePraise/find', Request.paginationBody(options, pagination))
  }
}
